import { useEffect, useState } from 'react'

import { useTranslation } from '@/shared/hooks/useTranslation'
import { Button } from '@/shared/ui/Button'

type QuestQuizFeedbackProps = {
  correct: boolean
  pointsDelta: number
  seconds?: number
  onContinue: () => void
}

export function QuestQuizFeedback({
  correct,
  pointsDelta,
  seconds = 3,
  onContinue
}: QuestQuizFeedbackProps) {
  const { t } = useTranslation()
  const [secondsLeft, setSecondsLeft] = useState(seconds)

  useEffect(() => {
    if (secondsLeft <= 0) {
      onContinue()
      return undefined
    }

    const timer = setTimeout(() => setSecondsLeft(value => value - 1), 1000)
    return () => clearTimeout(timer)
  }, [secondsLeft, onContinue])

  return (
    <div className="flex w-full items-center justify-between gap-3 rounded-xl bg-gray-50 p-3">
      <div>
        <p className="m-0 text-sm font-bold text-gray-900">
          {correct ? t('quests.quiz.feedbackCorrectTitle') : t('quests.quiz.feedbackIncorrectTitle')}
        </p>
        <p className="m-0 text-xs text-gray-500">
          {correct
            ? t('quests.quiz.feedbackCorrectDescription')
            : t('quests.quiz.feedbackIncorrectDescription')}
        </p>
        {pointsDelta > 0 && (
          <p className="m-0 text-xs font-bold text-[var(--color-brand)]">
            {t('quests.quiz.pointsEarned', { points: pointsDelta })}
          </p>
        )}
      </div>
      <Button variant="primary" size="sm" onClick={onContinue}>
        {t('quests.quiz.continue')} ({secondsLeft})
      </Button>
    </div>
  )
}
